<template>
  <div>
    <app-nav :full-name="userFullName" />

    <div class="columns">
      <div class="column"/>
      <div class="column is-three-quarters">

        <h1 class="title">PDF Split</h1>
        <!-- pdf split form -->
        <form @submit.prevent="splitPdf">

          <b-field class="file has-name">
            <b-upload
              v-model="documents"
              accept="pdf"
              @input="onFileInput">
              <a class="button is-info">
                <b-icon icon="upload" />
                <span>Choose a file...</span>
              </a>
            </b-upload>
            <span
              v-if="documents && documents.length"
              class="file-name">
              {{ documents[0].name }}
            </span>
          </b-field>

          <b-field label="Rows">
            <b-input
              v-model="rows"
              name="rows"
              placeholder="Enter a number" />
          </b-field>

          <b-field label="Columns">
            <b-input
              v-model="columns"
              name="columns"
              placeholder="Enter a number" />
          </b-field>

          <div class="field is-grouped">
            <div class="control">
              <button
                class="button is-primary">Upload</button>
            </div>
          </div>

        </form>

      </div>
      <div class="column"/>
    </div>

  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { uploadPdfSplit } from '../utils/api'
import { downloadContent } from '../utils/http'

export default {
  name: 'pdf',
  components: {
    AppNav
  },
  data() {
    return {
      // navbar
      userFullName: '',
      // input values
      documents: [],
      rows: '',
      columns: ''
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.userFullName = JSON.parse(getUser()).fullName
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    onFileInput(files) {
      if (files.length === 0) {
        this.$toast.open({
          message: 'Please choose a PDF file',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
      }
    },
    splitPdf() {
      let self = this
      let FormData = require('form-data')

      if (self.documents.length === 0) {
        self.$toast.open({
          message: 'Please choose a PDF file',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }
      if (self.rows.trim() === '') {
        self.$toast.open({
          message: 'Please enter a number for "Rows"',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }
      if (self.columns.trim() === '') {
        self.$toast.open({
          message: 'Please enter a number for "Columns"',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }

      let form = new FormData()
      form.append('rows', this.rows)
      form.append('columns', this.columns)
      form.append('document', this.documents[0])

      uploadPdfSplit(form).then((response) => {
        self.$toast.open({
          message: 'PDF split succeeded',
          duration: 3000,
          position: 'is-top',
          type: 'is-success'
        })
        downloadContent(response)
      }).catch(function() {
        self.$toast.open({
          message: 'PDF split failed',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .file-name-no-border {
    border-width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pdf.vue